module.exports = __webpack_public_path__ + "img/bg_fgyl.1c586c26.svg";